export default {"src":"/_next/static/media/slothLoading.31469f63.gif","height":600,"width":800,"blurWidth":0,"blurHeight":0};